<template>
  <div class="wrap" id="wrap">
    <div class="wrapper" style="padding-bottom: 0">
      <!--<div class="search-header">-->
        <!--<div class="search-header-text"><span class="arrow-back"></span>搜索条件</div>-->
      <!--</div>-->
      <div class="knowledge-list">
        <div class="knowledge-Downloads">
          <div class="knowledge-Downloads-name" v-if="countMax">
            抱歉您的（下载量/浏览量）已达（单日/本月/合计）最高次数。<br>
          </div>
          <div class="knowledge-Downloads-name" v-if="nopermission">
            抱歉，暂无权限<br>
          </div>
          <p class="QR-code" v-if="countMax">扫描下方二维码，联系小助手领取更多使用次数。</p>
          <p class="QR-code" v-if="nopermission">扫描下方二维码，联系小助手升级VIP用户。</p>
          <div class="knowledge-tag-head">
            <img src="../../../static/images/two-codes.png">
          </div>
        </div>
      </div>
    </div>
    <!-- /.wrapper -->
  </div>

</template>

<script>
  import userMix from '../../common/userMix'

  export default {
    name: 'LimitView',
    mixins: [userMix],
    data () {
      return {
        nopermission: false,
        countMax: false
      }
    },
    ready () {
      this.$nextTick(function () {
        // 设置页面最低高度等于屏幕可是区域高度
        let innerHeight = window.innerHeight + 'px'
        $('.wrapper').css({'min-height': innerHeight})
        $('.knowledge-list').css({'min-height': innerHeight})
        console.log($('.wrapper'))
        console.log(innerHeight)
      })
    },
    route: {
      data ({to}) {
        this.nopermission = false
        this.countMax = false
//        this.getProfile()
//        this.backHistory()
//        console.log(to)
        if (to.query.typ === '1') {
          this.nopermission = true
        }
        if (to.query.typ === '2') {
          this.countMax = true
        }
      }
    }
  }
</script>

<style scoped>
</style>



/** WEBPACK FOOTER **
 ** Limit.vue?4b18ffd5
 **/